const bridgeUrl = 'https://bridge.brunarosso.com/rest/cartres';

const checkKabiaStock = async ({ kabiaId, size, quantity, variantId }) => {
  if (!kabiaId) throw new Error('Codice Kabia mancante per questo prodotto.');

  const normalizedSize = String(size || '').trim().toUpperCase();
  const normalizedQuantity = Number(quantity);
  if (!normalizedSize || !Number.isInteger(normalizedQuantity) || normalizedQuantity < 1) {
    throw new Error('Dati prodotto non validi per la verifica della disponibilità.');
  }

  let requestedQuantity = normalizedQuantity;
  if (variantId) {
    const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`, { cache: 'no-store' });
    if (!cartResponse.ok) throw new Error('Impossibile verificare la quantità nel carrello.');
    const cart = await cartResponse.json();
    requestedQuantity += cart.items
      .filter(item => String(item.variant_id) === String(variantId))
      .reduce((total, item) => total + item.quantity, 0);
  }

  const url = new URL(bridgeUrl);
  url.searchParams.set('kabia_id', kabiaId);
  url.searchParams.set('size', normalizedSize);
  url.searchParams.set('quantity', requestedQuantity);

  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 10000);

  try {
    const response = await fetch(url.toString(), {
      method: 'GET',
      mode: 'cors',
      cache: 'no-store',
      signal: controller.signal,
    });
    if (!response.ok) throw new Error('Verifica della disponibilità temporaneamente non disponibile.');

    const result = await response.json();
    if (typeof result.success !== 'boolean') {
      throw new Error('Risposta non valida dalla verifica della disponibilità.');
    }
    if (!result.success) {
      throw new Error(result.message || 'Articolo esaurito per la quantità richiesta.');
    }
  } finally {
    clearTimeout(timeout);
  }
};

window.checkKabiaStock = checkKabiaStock;

export default checkKabiaStock;
